import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/global.css";
import "@mui/material/styles";
import "@mui/material/CssBaseline";
import App from "./App";
import { Buffer } from "buffer"; // Import Buffer

// Initialize global Buffer
window.Buffer = Buffer;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);